import {
GET_AUDIT_DATES_LIST,
SET_AUDIT_DATES_LIST,
CREATE_AUDIT,
CREATE_AUDIT_SUCCESS,
UPDATE_AUDIT,
UPDATE_AUDIT_SUCCESS,
DELETE_AUDIT,
DELETE_AUDIT_SUCCESS,
} from "./AuditDatesTypes"

const getAuditDatesList = (id?: any) => {
    return {
        type: GET_AUDIT_DATES_LIST,
        id
    }
}

const setAuditDatesList = (auditList: any) => {
    return{
    type: SET_AUDIT_DATES_LIST,
    auditList
}}

const createAudit = (audit: any) => ({
    type: CREATE_AUDIT,
    audit
});

const setAuditCreationSuccess = (response: any) => ({
    type: CREATE_AUDIT_SUCCESS,
    response
})

const updateAudit = (audit: any) => ({
    type: UPDATE_AUDIT,
    audit
});

const setAuditUpdationSuccess = (response: any) => ({
    type: UPDATE_AUDIT_SUCCESS,
    response
})

const deleteAudit = (audit: any) => ({
    type: DELETE_AUDIT,
    audit
});

const setAuditDeletionSuccess = (isAuditDeleted: any) => ({
    type: DELETE_AUDIT_SUCCESS,
    isAuditDeleted
})

export {
    getAuditDatesList,
    setAuditDatesList,
    createAudit,
    setAuditCreationSuccess,
    updateAudit,
    setAuditUpdationSuccess,
    deleteAudit,
    setAuditDeletionSuccess
}